// extracted by mini-css-extract-plugin
export default {"iconSuccess":"I2UCK","success-icon":"ipvjk","save":"P0i83"};